import { Box, Flex, Grid, Image, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { COMMON_WEB_PATH } from "../../../../constant";
import { Link, NavLink, useLocation, useSearchParams } from "react-router-dom";
import i18next, { t } from "i18next";
import useHotType from "../../../../hook/useHotType";

const HotTypeMenu = () => {
  const location = useLocation();

  const { hotType } = useHotType();

  const [searchParams] = useSearchParams();

  const searchParamsType = searchParams.get("type") || "Popular";

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      el?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.hash]);
  return (
    <Grid
      templateColumns={"repeat(3, 1fr)"}
      w="100%"
      h="60px"
      position="relative"
    >
      <Box
        position="absolute"
        top="0"
        left="0"
        w="100%"
        h="100%"
        opacity={0.6}
        bgImage={`url(${COMMON_WEB_PATH}/theOne/menu/hot_type_banner.png)`}
        bgSize="100% 100%"
        bgPos="center"
        bgRepeat={"no-repeat"}
        zIndex={-1}
      ></Box>

      {hotType.map((item) => {
        return (
          <Flex
            as={NavLink}
            to={{
              search: `?type=${item.hash}`,
            }}
            align={"center"}
            gap="5px"
            justifyContent={"center"}
            position="relative"
            _before={{
              content: "''",
              position: "absolute",
              w: "3px",
              h: "100%",
              right: "0px",
              top: "0px",
              bgImage: `url(${COMMON_WEB_PATH}/theOne/menu/hot_type_line.png)`,
              bgSize: "contain",
              bgRepeat: "no-repeat",
              bgPosition: "center",
            }}
            _after={{
              content: "''",
              position: "absolute",
              w: "100%",
              h: "100%",
              left: "0px",
              top: "0px",
              bgImage: `${COMMON_WEB_PATH}/theOne/header/menu_active_light.png`,
              bgSize: "100% 110%",
              bgRepeat: "no-repeat",
              backgroundPositionY: "-5px",
              display: searchParamsType === item.hash ? "block" : "none",
            }}
          >
            <Image
              w="20px"
              src={`${COMMON_WEB_PATH}/theOne/header/${item.type}_icon.png`}
            />
            <Box>
              <Text
                fontWeight={"400"}
                fontSize="14px"
                textShadow={"0 0 1.5px white"}
              >
                {t(`common.${item.label}`)}
              </Text>
            </Box>
          </Flex>
        );
      })}
    </Grid>
  );
};

export default HotTypeMenu;
